
import * as $ from 'jquery';

export default class Footer {

    constructor() {
        $('#footer-content label.title').each(function() {
            var checkbox = $('#' + $(this).attr('for'));

            $(this).click(e => {
                if (checkbox.is(':checked')) {
                    checkbox.prop('checked', false);
                    e.preventDefault();
                }
            });
        });
    }
}